/**
 * Keeps header / drawer BoM links in sync with bomStore line counts,
 * and syncs `aria-expanded` on the BoM drawer trigger.
 */
import { bomStore, BOM_CHANGE_EVENT } from '@theme/bom-store';
import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

function updateBomLinks() {
  const count = bomStore.lineCount;

  for (const link of document.querySelectorAll('[data-bom-link]')) {
    const badge = link.querySelector('[data-bom-count]');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }

    const template = link.dataset.bomAriaTemplate || '';
    if (template.includes('__COUNT__')) {
      link.setAttribute('aria-label', template.replaceAll('__COUNT__', String(count)));
    } else {
      link.setAttribute('aria-label', `Bill of materials, ${count} lines`);
    }
  }
}

function syncBomTriggerAriaExpanded() {
  const bomDrawer = document.getElementById('bom-drawer');
  if (!bomDrawer) return;

  for (const trigger of document.querySelectorAll('[aria-controls="bom-drawer"]')) {
    trigger.setAttribute('aria-expanded', bomDrawer.hasAttribute('open') ? 'true' : 'false');
  }
}

/**
 * @param {Event} event
 */
function onDrawerStateChange(event) {
  const target = /** @type {HTMLElement | null} */ (event.target);
  if (target?.id !== 'bom-drawer') return;
  syncBomTriggerAriaExpanded();
}

async function init() {
  await bomStore.init();
  updateBomLinks();
  syncBomTriggerAriaExpanded();
  document.addEventListener(BOM_CHANGE_EVENT, updateBomLinks);
  document.addEventListener(DrawerOpenEvent.eventName, onDrawerStateChange);
  document.addEventListener(DrawerCloseEvent.eventName, onDrawerStateChange);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
